export enum AppointmentRequestSourceFilter {
  All = 'All',
  AI = 'AI',
  AppointmentForm = 'AppointmentForm',
  WebsiteWidget = 'WebsiteWidget'
}
